var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tinymce-editor"
  }, [_c("Editor", {
    attrs: {
      id: _vm.editorId,
      init: _vm.editorInit
    },
    on: {
      onClick: _vm.onClick
    },
    model: {
      value: _vm.editorValue,
      callback: function callback($$v) {
        _vm.editorValue = $$v;
      },
      expression: "editorValue"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };